import { useSelector } from 'react-redux'
import { userSelector } from '@src/selectors/app'
import { UserReferralPartner } from '@src/types'

export const useIsDexcomPartnerUser = () => {
  const user = useSelector(userSelector)
  const { referralPartner } = user || {}

  return (
    referralPartner?.key === UserReferralPartner.Dexcom ||
    referralPartner?.key === UserReferralPartner.Stelo
  )
}
